export default ($axios) => ({
  fetch(query) {
    return $axios.get('/rcs/campaigns', { params: query }).then((response) => response.data);
  },
});
